export const formatNumber = (value: string | number, options?: Intl.NumberFormatOptions) => {
  const currency = options?.currency;
  const formatOptions = options || {};
  delete formatOptions.currency;

  try {
    let number = Number(value);
    // Convert -0 to 0 to avoid displaying "-$0"
    if (Object.is(number, -0)) {
      number = 0;
    }
    // Also handle very small negative numbers that round to 0
    if (number < 0 && Math.abs(number) < 0.01) {
      number = 0;
    }

    const resolvedOptions: Intl.NumberFormatOptions = {
      notation: "compact",
      maximumFractionDigits: 2,
      currency,
      style: currency ? "currency" : "decimal",
      // @ts-ignore valid
      trailingZeroDisplay: "stripIfInteger",
      ...formatOptions,
    };

    // With only a maximum set, how many trailing zeros survive on a currency
    // value is decided by the host's ICU build — the same amount renders
    // "€12.50" or "€12.5" depending on the browser. Pin the minimum so the
    // output is identical everywhere. Callers asking for fewer digits (chart
    // axes use maximumFractionDigits: 0) keep their setting: a minimum above
    // the maximum makes Intl throw.
    if (
      currency &&
      resolvedOptions.minimumFractionDigits === undefined &&
      (resolvedOptions.maximumFractionDigits ?? 2) >= 2
    ) {
      resolvedOptions.minimumFractionDigits = 2;
    }

    return Intl.NumberFormat("en", resolvedOptions).format(number);
  } catch (e) {
    console.error("Error in formatNumber", e, currency);
    return `${currency || ""}${value}`;
  }
};

export const getCurrencySymbol = (currencyCode: string | undefined) => {
  if (!currencyCode) {
    return "";
  }
  try {
    return (0)
      .toLocaleString("en", {
        style: "currency",
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
      .replace(/\d/g, "")
      .trim();
  } catch (e) {
    console.error("Error in getCurrencySymbol", e, currencyCode);
    return "$";
  }
};
